/* eslint-disable  */

import { api } from '../api';

export const sessionApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getSessions: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['SessionList']
        }),
        getSessionDetails: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['SessionDetails']
        }),
        addUpdateSession: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: payload.cls_id ? 'update' : 'create'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails'] : [])
        }),
        deleteSession: builder.mutation({
            query: (payload) => ({
                url: `api/classroom/classroom-pdc-session/`,
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DELETE'
                }
            }),
            invalidatesTags: ['SessionList']
        }),
        attendanceCheckinCheckout: builder.mutation({
            query: ({ payload, checkin }) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: checkin === 'checkin' ? 'studcheckin' : checkin === 'checkout' ? 'studcheckout' : 'studtcont'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),
        markAttendanceAbsent: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'mark_absent_pdcattendance'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),
        bulkCheckout: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'bulkstudcheckout'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),
        therapyCheckinCheckout: builder.mutation({
            query: ({ payload, checkin }) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: checkin ? 'studthrpyin' : 'studthrpyout'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),

        getTherapyHistory: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'studthrpyhistory'
                }
            })
        }),
        updateTherapyHistory: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'studthrpyhistoryupdate'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails'] : [])
        }),

        eSign: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails', 'UnsignedReportsList'] : [])
        }),
        ecdsESign: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'supervisor_sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails', 'UnsignedReportsList'] : [])
        }),
        getSwitchClassrooms: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['ClassroomList']
        }),
        switchClassroom: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'switchsession'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails', 'StudentList'] : [])
        }),

        addExternalStudent: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'externadd'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails', 'StudentList'] : [])
        }),
        addInternalStudent: builder.mutation({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'internaladd'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails', 'StudentList'] : [])
        }),
        lockUnlockSession: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'lock'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionDetails', 'SessionList'] : [])
        }),

        // session goals
        getSessionGoals: builder.query({
            query: (payload) => ({
                url: 'api/classroom/student-goals/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'lstsesngls'
                }
            }),
            providesTags: ['SessionGoals']
        }),
        addStudentGoalsResult: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/student-goals/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'adstdgolrslt'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionGoals'] : [])
        }),
        updateStudentGoalsRes: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/student-goals/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'update_percentage_response'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionGoals'] : [])
        }),
        getSessionHistory: builder.query({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'activity'
                }
            }),
            invalidatesTags: ['SessionHistory']
        }),
        getPdcSessionServiceAvailed: builder.query({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'serviceavailed'
                }
            })
        }),
        getSessionStudents: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'studlst'
                }
            }),
            providesTags: ['SessionStudentList']
        }),
        changeStudentAttendance: builder.mutation({
            query: ({ payload, present }) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: present ? 'pdcattendance' : 'pdcpickup'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['StudentList', 'SessionStudentList', 'SessionDetails'] : [])
        }),
        updateStudentAttendance: builder.mutation({
            query: ({ payload }) => ({
                url: '/api/classroom/classroom-pdc/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'update_pdcattendance'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['StudentList', 'SessionStudentList', 'SessionDetails'] : [])
        }),
        startSession: builder.mutation({
            query: (payload) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'checkincheckout'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails'] : [])
        }),
        getEarlyDismissalReasons: builder.query({
            query: (payload) => ({
                url: 'api/core/early-dismiss-reason/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
        }),
        downloadAttendanceReports: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'dailyreport'
                },
                responseHandler: (res) =>
                    res.blob().then((blob) => ({
                        blob,
                        fileName: res.headers.get('content-disposition').split('filename=')[1],
                        type: res.headers.get('content-type')
                    }))
            })
        }),
        downloadMonthlyAttendanceReports: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'monthlyreport'
                },
                responseHandler: (res) =>
                    res.blob().then((blob) => ({
                        blob,
                        fileName: res.headers.get('content-disposition').split('filename=')[1],
                        type: res.headers.get('content-type')
                    }))
            })
        }),
        updateSessionTime: builder.mutation({
            query: ({ payload }) => ({
                url: 'api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'update'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['SessionList', 'SessionDetails'] : [])
        }),
        getStudentsDailyReport: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'dailyreport'
                }
            })
            // providesTags: ['SessionStudentList']
        }),
        getStudentsMonthlyReport: builder.query({
            query: (payload) => ({
                url: '/api/classroom/classroom-pdc-session/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'monthlyreport'
                }
            })
            // providesTags: ['SessionStudentList']
        })
    })
});

export const {
    useGetSessionsQuery,
    useGetSessionDetailsQuery,
    useGetTherapyHistoryQuery,
    useLazyGetTherapyHistoryQuery,
    useUpdateTherapyHistoryMutation,
    useAddUpdateSessionMutation,
    useDeleteSessionMutation,
    useAttendanceCheckinCheckoutMutation,
    useMarkAttendanceAbsentMutation,
    useBulkCheckoutMutation,
    useTherapyCheckinCheckoutMutation,
    useESignMutation,
    useEcdsESignMutation,
    useGetSwitchClassroomsQuery,
    useSwitchClassroomMutation,
    useAddExternalStudentMutation,
    useAddInternalStudentMutation,
    useLockUnlockSessionMutation,
    useGetSessionGoalsQuery,
    useAddStudentGoalsResultMutation,
    useUpdateStudentGoalsResMutation,
    useGetSessionHistoryQuery,
    useLazyGetSessionHistoryQuery,
    useGetPdcSessionServiceAvailedQuery,
    useGetSessionStudentsQuery,
    useChangeStudentAttendanceMutation,
    useUpdateStudentAttendanceMutation,
    useStartSessionMutation,
    useGetEarlyDismissalReasonsQuery,
    useLazyGetSessionStudentsQuery,
    useLazyGetStudentsDailyReportQuery,
    useLazyGetStudentsMonthlyReportQuery,
    useLazyDownloadAttendanceReportsQuery,
    useLazyDownloadMonthlyAttendanceReportsQuery,

    useUpdateSessionTimeMutation
} = sessionApi;
